import { eventTypes } from 'utils/eventTypes';

export const saveToLocalStorage = (key, value) => {
  if (window && !window.simulator) {
    localStorage.setItem(key, value);
  }
};

export const getFromLocalStorage = key => {
  if (window && !window.simulator) {
    return localStorage.getItem(key);
  }
};

export const deleteFromLocalStorage = key => {
  if (window && !window.simulator) {
    localStorage.removeItem(key);
  }
};

export const clearLocalStorage = () => {
  if (window && !window.simulator) {
    localStorage.clear();
  }
}

export const saveEventToLocalStorage = event => {
  if (
    event.eventType === eventTypes.USER_DATA_PROVIDED ||
    event.eventType === eventTypes.BUTTON_CLICKED ||
    event.eventType === eventTypes.PLAIN_INPUT_PROVIDED
  ) {
    const pathEvents = JSON.parse(getFromLocalStorage('pathEvents') || '[]');
    pathEvents.push(event);
    saveToLocalStorage('pathEvents', JSON.stringify(pathEvents));
  } else {
    const events = JSON.parse(getFromLocalStorage('events') || '[]');
    events.push(event);
    saveToLocalStorage('events', JSON.stringify(events));
  }
};

export const mergePathEventsAndEvents = () => {
  const pathEvents = JSON.parse(getFromLocalStorage('pathEvents') || '[]');
  const events = JSON.parse(getFromLocalStorage('events') || '[]');
  const mergedEvents = [...events, ...pathEvents];
  saveToLocalStorage('pathEvents', JSON.stringify([]));
  saveToLocalStorage('events', JSON.stringify(mergedEvents));
};
